import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Chip from '@mui/material/Chip';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import { Button } from "@material-ui/core";
import { format, addDays, isValid, parse } from 'date-fns';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@material-ui/core/TextField';

import SettingsIcon from '@mui/icons-material/Settings';


import {
    DataGrid, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';






function novoAgendamento() {
    window.location.href = "/gestao/operacional/agendamentos/cadastrar/-1/0/0";

}

export default function Agendamentos() {



    const [loading, setLoading] = useState(true);
    const [agendamentos, setAgendamentos] = useState([]);


    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/agendamentos/listartodos", {
                headers: headers
            }).then(function (response) {
                console.log("Agendamentos: " + JSON.stringify(response.data));
                setAgendamentos(response.data)

                setLoading(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Agendamentos: " + _err)

        }

    }


    useEffect(() => {




        listarInformacoes();


    }, []);





    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    function returnDescricaoStatusEquipe(status) {
        switch (status) {
            case -1:
                return "Desativado";
            case 0:
                return "Livre";
            case 1:
                return "Agendado - Não Iniciado";
            case 2:
                return "Agendado - Em Deslocamento para Tratamento de O.S em campo";
            case 3:
                return "Agendado - Tratando Equipe em Campo";
            case 4:
                return "Agendado - Retornando de Tratamento de O.S em campo";
            case 5:
                // Adicione mais casos conforme necessário
                return "Outro status";
            default:
                return "Status Desconhecido";
        }
    }



    function returnDescricaoEquipe(equipe) {
        var texto =  equipe.id_equipe +
            " | Nome: " + equipe.nome ;
 
        return texto;
    }

    function returnDescricaoVeiculo(veiculo) {


        var texto = "Placa: " + veiculo.placa;



        return texto;
    }




    const CustomCell = ({ value }) => (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
            {value.map((descricao, index) => (

                <Chip key={index} label={descricao} />

            ))}
        </div>
    );

    const columnsDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 100,
            renderCell: (cellValues) => {
                return (
                    <Grid>


                        <IconButton
                                                               color="primary"
                                                               size="small"
                                                               onClick={() => window.open(` /gestao/operacional/agendamentos/editar/${cellValues.row.id_agendamento}`, '_blank')}
                                                           >
                                                               <SettingsIcon fontSize="small" />
                                                           </IconButton>

                    </Grid>

                )
            },
        },
        {
            headerName: 'ID',
            field: 'id_agendamento',
            id: 1,
            width: 30,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Tipo',
            field: 'tipo_agendamento',
            id: 2,
            width: 300,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                try {
                    const tipo = parseInt(cellValues.row.tipo_agendamento, 10);
                    let text = "";

                    if (tipo === 0)
                        text = "Veículo: " + returnDescricaoVeiculo(cellValues.row.veiculo);
                    else if (tipo === 1)
                        text = "Equipe: " + returnDescricaoEquipe(cellValues.row.equipe);
                    else if (tipo === 2)
                        text =
                            "Veículo e Equipe:<br/>Veículo: " +
                            returnDescricaoVeiculo(cellValues.row.veiculo) +
                            "<br/>Equipe: " +
                            returnDescricaoEquipe(cellValues.row.equipe);

                    return (
                        <span
                            style={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                lineHeight: '1.4',
                                display: 'block',
                            }}
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    );
                } catch (_err) {
                    return <span>Dados Inválidos</span>;
                }
            },
        },
        {
            headerName: 'Escopo',
            field: 'escopo',
            id: 3,
            width: 300,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                try {
                    let dataHoraInicial;
                    let dataHoraFinal;

                    const dataHoraInicialRaw = cellValues.row.data_hora_inicial;
                    const dataHoraFinalRaw = cellValues.row.data_hora_final;

                    // --- Verifica o tipo de dado e converte ---
                    if (Array.isArray(dataHoraInicialRaw) && Array.isArray(dataHoraFinalRaw)) {
                        // Formato [ano, mês, dia, hora, minuto, segundo]
                        dataHoraInicial = new Date(
                            dataHoraInicialRaw[0],
                            dataHoraInicialRaw[1] - 1,
                            dataHoraInicialRaw[2],
                            dataHoraInicialRaw[3],
                            dataHoraInicialRaw[4],
                            dataHoraInicialRaw[5]
                        );

                        dataHoraFinal = new Date(
                            dataHoraFinalRaw[0],
                            dataHoraFinalRaw[1] - 1,
                            dataHoraFinalRaw[2],
                            dataHoraFinalRaw[3],
                            dataHoraFinalRaw[4],
                            dataHoraFinalRaw[5]
                        );
                    } else if (typeof dataHoraInicialRaw === "string" && typeof dataHoraFinalRaw === "string") {
                        // Formato "YYYY-MM-DD HH:mm:ss"
                        // Substitui o espaço por "T" para ser compatível com o construtor Date
                        dataHoraInicial = new Date(dataHoraInicialRaw.replace(" ", "T"));
                        dataHoraFinal = new Date(dataHoraFinalRaw.replace(" ", "T"));
                    } else {
                        throw new Error("Formato de data não reconhecido");
                    }

                    // --- Formata ---
                    const dataHoraInicialFormatada = format(dataHoraInicial, "HH:mm dd/MM/yyyy");
                    const dataHoraFinalFormatada = format(dataHoraFinal, "HH:mm dd/MM/yyyy");

                    const texto = `De ${dataHoraInicialFormatada} até ${dataHoraFinalFormatada}`;

                    return (
                        <span
                            style={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                display: 'block',
                                lineHeight: '1.4',
                            }}
                        >
                            {texto}
                        </span>
                    );
                } catch (_err) {
                    return <span style={{ color: 'red' }}>Data Inválida</span>;
                }
            },
        },
        {
            headerName: 'Motivo',
            field: 'motivo',
            id: 4,
            width: 400,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Descrição',
            field: 'descricao',
            id: 5,
            width: 600,
            headerClassName: 'cabecalho_azul',
        },


    ];




    return (
        <div>

            <NavegadorGestao
                Operacional={true}
                Agendamentos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />


            <div style={{ padding: 5, width: '100%', height: '100%' }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={12}
                >
                    <Button style={{ margin: 5 }}
                        variant="contained"
                        color="primary"
                        onClick={novoAgendamento}
                    >
                        Novo Agendamento
                    </Button>
                </Grid>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <div style={{ height: '100%', width: '100%' }}>
                        <>
                            <DataGrid

                                pagination
                                checkboxSelection
                                rows={agendamentos}
                                pageSize={20}
                                rowHeight={80}
                                getRowId={(row) => row.id_agendamento}
                                columns={columnsDataGrid}
                                disableColumnResize={false}
                                onCellClick={handleCellClick}
                                onRowClick={handleRowClick}
                                components={{
                                    Toolbar: CustomToolbar,
                                }}
                                sx={{
                                    '& .MuiDataGrid-cell': {
                                        whiteSpace: 'normal !important',
                                        wordBreak: 'break-word',
                                        lineHeight: '1.4',
                                        alignItems: 'flex-start', // alinha o topo
                                        display: 'block',
                                    },
                                }}

                            />

                        </>
                    </div>
                }


            </div>



        </div>
    );
}



